module.exports = __webpack_public_path__ + "img/checkout-bg.49b710f8.svg";